
define('text!TescoMobile_Esim/template/catalog/product/view/sim-preference.html',[],function () { return '<div class="sim-request-info" data-bind="visible: visible"><input name="sim_preference" type="hidden" data-bind="value: simPreference()"><div class="sub-items"><!-- ko foreach: elems() --> <!-- ko template: getTemplate() --><!-- /ko --><!-- /ko --></div></div>';});

